import {Authored} from "./common";
import {Equipment} from "./equipment";

export interface PurchaseOrder {
  id: string;
  status: PurchaseOrderStatus;
  name: string;
  manufacturerNames: string;
  salesOrderConfirmationNumber: string | null;
  salesOrderConfirmationDate: Date | null;
  estimatedShipByDate: Date | null;
  notes: string;
  equipmentIds: string[];
  equipment: Equipment[];
  created: Authored;
  updated: Authored;
}

export interface PurchaseOrderCreateRequest {
  status: PurchaseOrderStatus;
  name: string;
  notes: string;
  equipmentIds: string[];
}

export interface PurchaseOrderUpdateRequest {
  status?: PurchaseOrderStatus;
  name?: string;
  salesOrderConfirmationNumber?: string;
  salesOrderConfirmationDate?: Date;
  estimatedShipByDate?: Date;
  notes?: string;
  equipmentIds?: string[];
}

export interface PurchaseOrderMoveRequest {
  equipmentIds: string[],
  moveToPurchaseOrderId: string,
}

export enum PurchaseOrderStatus {
  GENERATED = "GENERATED",
  DRAFT = "DRAFT",
  PENDING_INFO = "PENDING_INFO",
  ORDERED = "ORDERED",
  COMPLETE = "COMPLETE",
  CANCELLED = "CANCELLED",
}
